import React from "react";
import { DocumentImportPanel } from "@/components/authority/KarateDocumentImportPanels.jsx";

export function DocumentsPreuvesImportPage() {
  return (
    <div data-testid="page-admin-documents-preuves-import">
      <DocumentImportPanel testId="documents-preuves-import-panel" />
    </div>
  );
}
